// extracted by mini-css-extract-plugin
export default {"_404":"SomethingWrong__404__yQQ9M","btn":"SomethingWrong_btn__8R7Ic"};